export const GET_LIST_START = "@jurisdictions/GET_LIST_START";
export const GET_LIST_SUCCESS = "@jurisdictions/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@jurisdictions/GET_LIST_FAIL";
export const GET_DETAIL_START = "@jurisdictions/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@jurisdictions/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@jurisdictions/GET_DETAIL_FAIL";
export const GET_COUNTRIES_START = "@jurisdictions/GET_COUNTRIES_START";
export const GET_COUNTRIES_SUCCESS = "@jurisdictions/GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAIL = "@jurisdictions/GET_COUNTRIES_FAIL";
export const RESET_STORE = "@jurisdictions/RESET_STORE";
